import { render } from "./EditSvgIcon.vue?vue&type=template&id=38b013d8"
import script from "./EditSvgIcon.vue?vue&type=script&lang=js"
export * from "./EditSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__